import { Button, Modal } from 'antd';

type StockOverrideModalProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const StockOverrideModal = ({
  open,
  onConfirm,
  onCancel,
}: StockOverrideModalProps) => (
  <Modal
    open={open}
    onCancel={onCancel}
    footer={
      <>
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="primary" onClick={onConfirm}>
          Yes, save changes
        </Button>
      </>
    }
    closable
    title="Override all manual stock"
  >
    This action will delete all manual stock data entered by the hotel for this
    experience. Are you sure you want to proceed?
  </Modal>
);
